// extracted by mini-css-extract-plugin
module.exports = {"schoolItem":"_1WcMGWTvUEQK0XV5WU42LS","wizardCard":"_3E4eW3rS2QcSosGWXDpxpq"};